import React from 'react';
import { Flag, Check, X } from 'lucide-react';

const VoteEndBanner = ({ activeVote, yourUsername, onVoteEnd }) => {
  if (!activeVote) return null;

  const { initiator_username, votes } = activeVote;
  const entries = Object.entries(votes);
  const acceptedCount = entries.filter(([, v]) => v === true).length;
  const totalCount = entries.length;
  const hasVoted = votes[yourUsername] !== null && votes[yourUsername] !== undefined;
  const isInitiator = initiator_username === yourUsername;

  return (
    <div className="flex items-center gap-3 px-4 py-2 bg-amber-900/30 border-b border-amber-700/50 text-sm">
      <Flag className="w-4 h-4 text-amber-400 shrink-0" />

      <span className="text-amber-200">
        <span className="font-semibold text-amber-100">{initiator_username}</span>
        {' '}propose de terminer la partie
        {' '}
        <span className="font-mono font-bold text-amber-100">
          ({acceptedCount}/{totalCount})
        </span>
      </span>

      {/* Player vote dots */}
      <div className="flex items-center gap-1.5">
        {entries.map(([username, vote]) => (
          <div
            key={username}
            title={`${username}: ${vote === true ? 'Accepte' : vote === false ? 'Refuse' : 'En attente'}`}
            className={`w-2.5 h-2.5 rounded-full ${
              vote === true ? 'bg-green-400' : 'bg-slate-500'
            }`}
          />
        ))}
      </div>

      <div className="ml-auto flex items-center gap-2">
        {isInitiator || (hasVoted && votes[yourUsername] === true) ? (
          <span className="text-green-400 text-xs">Vote enregistré</span>
        ) : (
          <>
            <button
              onClick={() => onVoteEnd('accept')}
              className="flex items-center gap-1 px-3 py-1 rounded bg-green-600 hover:bg-green-500 text-white text-xs font-medium transition-colors"
            >
              <Check className="w-3.5 h-3.5" />
              Accepter
            </button>
            <button
              onClick={() => onVoteEnd('decline')}
              className="flex items-center gap-1 px-3 py-1 rounded bg-red-600 hover:bg-red-500 text-white text-xs font-medium transition-colors"
            >
              <X className="w-3.5 h-3.5" />
              Refuser
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default VoteEndBanner;
